export default __webpack_public_path__ + "static/media/winner7.35305f8f.jpg";